import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { get } from 'lodash';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { withLocalize, Translate } from "react-localize-redux";
import { Circles } from '../common/loadingComponent';
import { isNullOrUndefined, isRepiWeb } from '../../store/storeFunctions';
import { object as YupObject, string as YupString } from '../common/Yup';
import { parseQuery, isObjectPathDefined, apiPost, getHostApi, getLanguage } from '../../store/apiWrapper';
import Message from '../common/message';
import BbInput from '../styling/bbInput';
import LanguageSelector from '../common/languageSelector';

import criftimelinetrees from '../../img/CrifTimelineTrees.svg';
import cribislogograyCz from "../../img/Cribis.cz_grey.svg";
import cribislogograySk from "../../img/Cribis.sk_grey.svg";
import cribislogowhiteCz from "../../img/Cribis.cz_white.svg";
import cribislogowhiteSk from "../../img/Cribis.sk_white.svg";
import crifCzColored from "../../img/CRIFcz_colored.svg";
import crifSkColored from "../../img/CRIFsk_colored.svg";

import RepiCzWhite from '../../img/repi/RepiCzWhite.svg';
import RepiSkWhite from '../../img/repi/RepiSkWhite.svg';
import RepiCzGrey from '../../img/repi/RepiCzGrey.svg';
import RepiSkGrey from '../../img/repi/RepiSkGrey.svg';
import RepiCzColor from '../../img/repi/REPI CZ.svg'
import RepiSkColor from '../../img/repi/REPI SK.svg'

import cribisCz from "../../img/Cribis.cz_grey2.svg";
import cribisSk from "../../img/Cribis.sk_grey2.svg";
import irating from "../../img/iRating2.svg";
import margo from "../../img/margo2.svg";
import repi from "../../img/REPI.svg";

import "./login.scss";

class LostPwdComponent extends React.Component {
    lastT = 0;
    constructor(props) {
        super(props);
        this.state = {
            token: '', loading: false, error: false, stage: 1, completed: false, user: '', checked: false, appLinks: null, apps: null,
            password_validation: this.getFalseValidationRules(),
            agentLanguage: 'cs-CZ'
        };

        const q = parseQuery(window.location.search);
        if (isObjectPathDefined(q, 'u') && isObjectPathDefined(q, 'rpt')) {
            this.state.loading = true;
            var app = isObjectPathDefined(q, 'app') ? q.app : null;
            this.checkTokenValidity(q.u, q.rpt, app);
            this.state.stage = 2;
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.state.stage === 1 &&
                    <LostPwdBackground>
                        <LostPwdAsForm>{this.renderStageOne()}</LostPwdAsForm>
                    </LostPwdBackground>
                }
                {this.state.stage !== 1 && (this.isStageTwoOrThreeMessage() || this.isStageTwoOrThreeLoading()) &&
                    <LostPwdBackground>
                        <LostPwdAsForm>
                            <div className='stage-2'>
                                {this.isStageTwoOrThreeMessage() &&
                                    <div className="column bb-login-notification">
                                        {this.renderMessage(false)}
                                    </div>
                                }
                                {this.isStageTwoOrThreeLoading() &&
                                    <div className="stage-2-container" style={{ display: "flex" }}>
                                        <Circles useLoginColor />
                                    </div>
                                }
                            </div>
                        </LostPwdAsForm>
                    </LostPwdBackground>
                }
                {this.state.stage !== 1 && !this.isStageTwoOrThreeMessage() && !this.isStageTwoOrThreeLoading() &&
                    <LostPwdAsForm style={{ margin: '0' }}>
                        <div className='stage-2'>
                            {this.renderStageTwoOrThree()}
                        </div>
                    </LostPwdAsForm>}
            </React.Fragment>
        );
    }

    renderStageOne = () => {
        if (this.state.completed) {
            return (
                <div className="column bb-login-notification">
                    {this.renderMessage(false)}
                </div>
            );
        }
        if (this.state.loading)
            return <Circles useLoginColor />;

        return (
            <div className={classnames("column", {
                "bb-login-box": localStorage.locales_login === 'tree',
                "bb-blue-login-box": localStorage.locales_login === 'blue'
            })}>
                <h4 className="bb-login-caption has-text-centered">{this.props.translate('PwdReset.FormCaption')}</h4>
                <div className="progress-wrapper">
                    <div className='bb-login-progress' />
                </div>
                <div className="bb-login-body">
                    <Formik
                        initialValues={{ username: '', email: '' }}
                        onSubmit={(values) => this.handleSubmit(values)}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={YupObject().shape({
                            username: YupString().test('length', this.props.translate('PwdReset.Username'), (v) => !isNullOrUndefined(v) && v !== ''),
                            email: YupString().test('length', this.props.translate('PwdReset.UserEmail'), (v) => !isNullOrUndefined(v) && v !== '')
                        })}
                    >
                        {({ errors }) => <Form autoComplete="off">
                            {Object.keys(errors).length > 0 && <Message type="error" message={this.props.translate("Error.InvalidParams") + ':'}>
                                <ul style={{ listStyleType: "disc" }}>
                                    {Object.keys(errors).map(k => <li key={k} style={{ marginLeft: "3em" }}>{errors[k]}</li>)}
                                </ul>
                            </Message>}
                            <BbInput name="username" type="text" label={this.props.translate('PwdReset.Username')}
                                placeholder={{ type: 'static' }} icon={{ left: 'user' }} showError={false} />
                            <BbInput name="email" type="text" label={this.props.translate('PwdReset.UserEmail')}
                                placeholder={{ type: 'static' }} icon={{ left: 'lock' }} showError={false} />
                            <div className="bb-group" style={{ display: "flex", justifyContent: "center" }}>
                                <button
                                    className={classnames('bb-button bb-login-button gradient-1',
                                        { 'bb-login-button-less-padding': this.state.loading, 'is-square': localStorage.locales_button_style === 'square' })}
                                    type="submit" disabled={this.submitDisabled()}
                                >
                                    <Translate id='PwdReset.BtnReset' />
                                </button>
                            </div>
                            <div className="bb-group" style={{
                                fontSize: '.9em',
                                textAlign: localStorage.locales_login === 'tree' ? 'right' : 'center',
                                paddingTop: localStorage.locales_login === 'tree' ? '.5em' : '1.5em'
                            }}>
                                <Link className="bb-link" to="/login">{this.props.translate('Login.BackToLogin')}</Link>
                            </div>
                        </Form>}
                    </Formik>
                </div>
                {localStorage.locales_login === 'blue' &&
                    <div className='blue-login-language-flags'>
                        <LanguageSelector />
                    </div>
                }
            </div>
        );
    }

    isStageTwoOrThreeMessage = () => this.state.checked && !this.state.completed && this.state.error;

    isStageTwoOrThreeLoading = () => this.state.stage === 2 && this.state.loading;

    renderStageTwoOrThree = () => {
        if (this.isMobile())
            return this.renderFormOfStageTwoOrThree();

        return (
            <div className='columns is-desktop stage-2-container'>
                <div className='column'>
                    <div className="left-half">
                        {this.renderFormOfStageTwoOrThree()}
                    </div>
                </div>
                <div className='column'>
                    <div className='right-half'>
                        <div className='text'>
                            <div className='header'>{this.props.translate('PwdReset.ValidationText.Header')}</div>
                            {this.renderRules()}
                            <div className='footer'>{this.props.translate('PwdReset.ValidationText.Security')}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderFormOfStageTwoOrThree = () => {
        return (
            <div className={classnames("column", {
                "bb-login-box": localStorage.locales_login === 'tree',
                "bb-blue-login-box": localStorage.locales_login === 'blue'
            })}>
                <div style={{ width: '100%' }} align={this.isMobile() ? 'center' : 'left'}>
                    {isRepiWeb()
                        ? <img alt="" className='stage-2-container-cribis-logo' src={this.state.agentLanguage === 'sk-SK' ? RepiSkColor : RepiCzColor}></img>
                        : <img alt="" className='stage-2-container-cribis-logo' src={this.state.agentLanguage === 'sk-SK' ? crifSkColored : crifCzColored}></img>}
                </div>
                <div style={{ width: '100%' }} align={this.isMobile() ? 'center' : 'left'}>
                    <div className="bb-login-caption">{this.props.translate('PwdReset.CreateNewPassword.Caption')}</div>
                    <div className="bb-login-subcaption">{this.props.translate('PwdReset.CreateNewPassword.Subcaption')}</div>
                </div>

                <div style={{ height: '1em' }} />
                {this.state.stage === 2 && <div className="bb-login-body">
                    {this.state.error &&
                        this.showError('error', this.state.message)}
                    <Formik
                        initialValues={{ username: this.state.user, newPwd: '', confirmPwd: '' }}
                        validate={values => {
                            let errors = {};
                            if (values.newPwd === undefined || values.newPwd === "")
                                errors.newPwd = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.NewPassword') });
                            if (values.confirmPwd === undefined || values.confirmPwd === "")
                                errors.confirmPwd = this.props.translate('Form.Validation.Required', { name: this.props.translate('PswdChange.ConfirmPassword') });
                            return errors;
                        }}
                        onSubmit={(values) => this.handleNewPwd(values)}
                    >
                        {({ values, errors, touched, isSubmitting }) => <Form>
                            <BbInput name="username" type="text" disabled={true} label={this.props.translate('PwdReset.Username')}
                                placeholder={{ type: 'static' }} icon={{ left: 'user' }} showError={false} />
                            {this.isMobile() && <div className='stage-2-mobile'>{this.renderRules()}</div>}
                            <BbInput name="newPwd" type="password" label={this.props.translate('PswdChange.NewPassword')} onInput={this.validatePassword}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            <BbInput name="confirmPwd" type="password" label={this.props.translate('PswdChange.ConfirmPassword')}
                                placeholder={{ type: 'static' }} error={{ errors, touched }} icon={{ left: 'lock' }} />
                            {this.fieldsFilled(values) && !this.pswdMatch(values) &&
                                <p className="help is-danger">{this.props.translate('PswdChange.PswdsDontMatch')}</p>}
                            <div className="bb-group" style={{ display: "flex", justifyContent: "center" }}>
                                <button
                                    className={classnames('bb-button bb-login-button gradient-1',
                                        { 'bb-login-button-less-padding': this.state.loading, 'is-square': localStorage.locales_button_style === 'square' })}
                                    type="submit" disabled={isSubmitting || !this.isFormValid(values)}
                                >
                                    <Translate id='PswdChange.SubmitBtn' />
                                </button>
                            </div>
                        </Form>}
                    </Formik>
                </div>}
                {this.state.stage === 3 && this.state.loading && <Circles />}
                {this.state.stage === 3 && !this.state.loading && this.renderStageThree()}
                {this.state.stage === 2 && this.isMobile() &&
                    <div className='text-x1' style={{ fontSize: '15px', marginTop: '1em', marginBottom: '2em', width: '80%', marginLeft: '10%', color: 'black' }}>
                        {this.props.translate('PwdReset.ValidationText.Security')}
                    </div>}
                <div style={{ marginTop: this.state.stage === 2 && this.isMobile() ? '10px' : '3em', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {this.isAppMember('MultiCribis') && <div style={{ padding: '0px 10px 10px 10px', width: '31%' }} >
                        <a target="_blank" href={this.getAppLink('MultiCribis')}>
                            <img className='reset-password-container-logos-logo' src={this.state.agentLanguage === 'sk-SK' ? cribisSk : cribisCz} />
                        </a>
                    </div>}
                    {this.isAppMember('iRating') && <div style={{ padding: '6px 10px 10px 10px', width: '23%' }} >
                        <a target="_blank" href={this.getAppLink('iRating')}>
                            <img className='reset-password-container-logos-logo' src={irating} />
                        </a>
                    </div>}
                    {this.isAppMember('Margo') && <div style={{ padding: '6px 10px 10px 10px', width: '23%' }} >
                        <a target="_blank" href={this.getAppLink('Margo')}>
                            <img className='reset-password-container-logos-logo' src={margo} />
                        </a>
                    </div>}
                    {this.isAppMember('Repi') && <div style={{ padding: '6px 10px 10px 10px', width: '23%' }} >
                        <a target="_blank" href={isRepiWeb() ? this.getAppLink('Repi') : this.getAppLink('RepiInCribis')}>
                            <img className='reset-password-container-logos-logo' src={repi} />
                        </a>
                    </div>}
                </div>
                <div className='crif-copyright-text text-x1'>
                    {isRepiWeb()
                        ? <>&copy; CRIF - {this.state.agentLanguage === 'sk-SK' ? 'Slovak Credit Bureau, s.r.o.' : 'Registr platebních informací, s.r.o.'}</>
                        : <>&copy; CRIF - {this.state.agentLanguage === 'sk-SK' ? 'Slovak Credit Bureau, s.r.o.' : 'Czech Credit Bureau, a.s.'} </>}
                </div>
                {localStorage.locales_login === 'blue' &&
                    <div className='blue-login-language-flags' style={{ marginTop: '10px' }}>
                        <LanguageSelector />
                    </div>
                }
            </div>);
    }

    renderRules = () => {
        return (
            <>
                <div className={`rule ${this.state.password_validation.minimal === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.Minimal')}</div>
                <div className={`rule ${this.state.password_validation.uppercase === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.Uppercase')}</div>
                <div className={`rule ${this.state.password_validation.lowercase === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.Lowercase')}</div>
                <div className={`rule ${this.state.password_validation.digits === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.Digits')}</div>
                <div className={`rule ${this.state.password_validation.special_character === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.SpecialCharacter')}</div>
                <div className={`rule ${this.state.password_validation.max_three_same_characters === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.MaxThreeSameCharacters')}</div>
                <div className={`rule ${this.state.password_validation.no_6_repeatings === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.No6Repeatings')}</div>
                <div className={`rule ${this.state.password_validation.no_pointer_to_user === true ? 'validated' : ''}`}>{this.props.translate('PwdReset.ValidationText.NoPointerToUser')}</div>
            </>
        );
    }

    renderStageThree = () => (
        <>
            {this.state.completed && <Message type='success' shadowed={true} message={this.props.translate('PwdReset.ResetWithoutMailSuccess')} />}
        </>
    );

    renderMessage = (shadowed) => {
        return (this.state.completed || this.state.checked) && (
            <Message type={this.state.error ? 'error' : 'success'} shadowed={shadowed} message={
                <>
                    <div>{ReactHtmlParser(this.checkTranslation(this.props.translate(this.state.message)))}</div>
                    {this.state.stage == 1 && <div>
                        {this.state.error
                            ? <span className="bb-link" onClick={() => this.setState({ completed: false })}>{this.props.translate('PwdReset.Back')}</span>
                            : <Link className="bb-link" to={"/login"}>{this.props.translate('PwdReset.Back')}</Link>}
                    </div>}
                </>
            } />
        );
    }

    showError = (type, message) => {
        if (message === null || message === undefined)
            return "";
        return (<Message type={type} message={this.checkTranslation(this.props.translate(message))} style={{ fontSize: '.8em', marginBottom: '1em' }} options={{ renderInnerHtml: true }} shadowed />);
    };

    submitDisabled = () => this.state.loading;

    checkTokenValidity = (token, user, app) => {
        apiPost(getHostApi() + '/api/account/check-reset-token', undefined, { token, user, app },
            (res) => this.setState({
                error: !res.data.success, message: res.data.errorMessage, token: token, user: user,
                agentLanguage: res.data.agentLanguage, appLinks: res.data.appLinks, apps: this.processAppIds(res.data.appIds)
            }),
            (err) => this.setState({ error: true, message: this.getErrorMessage(err) }),
            () => this.setState({ loading: false, checked: true }));
    }

    handleSubmit = (values) => {
        this.setState({ loading: true, error: false, message: undefined });
        apiPost(getHostApi() + '/api/account/reset-pwd', undefined, { userName: values.username, email: values.email, repi: isRepiWeb() },
            (res) => {
                if (!isNullOrUndefined(res.data))
                    this.setState({ error: !res.data.success, message: res.data.errorMessage })
                else if (!isNullOrUndefined(res.error))
                    this.setState({ error: true, message: this.getErrorMessage(res, "error.message") })
            },
            (err) => this.setState({ error: true, message: this.getErrorMessage(err) }),
            () => this.setState({ loading: false, completed: true }));
    }

    handleNewPwd = (values) => {
        this.setState({ loading: true, error: false, message: undefined, stage: 3 });
        apiPost(getHostApi() + '/api/account/set-pwd', undefined, { user: this.state.user, token: this.state.token, newPwd: values.newPwd, confirmPwd: values.confirmPwd },
            (res) => {
                this.setState({ error: !res.data.success, message: res.data.errorMessage, stage: res.data.success ? 3 : 2, appLinks: res.data.appLinks, apps: this.processAppIds(res.data.appIds) });
                if (!res.data.success)
                    this.setState({ password_validation: this.getFalseValidationRules() });
            },
            (err) => this.setState({ error: true, message: this.getErrorMessage(err), stage: 2 }),
            () => this.setState({ loading: false, completed: true }));
    }

    setLastT = (t) => {
        this.lastT = t;
    }

    validatePassword = (e) => {
        var pass = e.target.value;
        apiPost(getHostApi() + '/api/account/validate-pwd', null, { username: this.state.user, newPswd: pass, t: Date.now() },
            (res, lastT = this.lastT) => {
                if (res.data !== null && res.data.t > lastT) {
                    this.setLastT(res.data.t);
                    pass = document.getElementsByName("newPwd")[0];
                    if (pass != null) pass = pass.value;
                    if (pass == null || pass == '') {
                        this.setState({ password_validation: this.getFalseValidationRules() });
                        return;
                    }
                    this.setState({ password_validation: res.data });
                }
            }
        );
    }

    checkTranslation = (translation) => {
        if (translation.startsWith('-') && translation.endsWith('-'))
            return translation.substring(1, translation.length - 1);
        return translation;
    }

    getErrorMessage = (err, path = "data.error.message") => {
        try {
            const errorMsg = get(err, path);
            return errorMsg.startsWith("UnhappyUser") ? errorMsg : "Common.Error";
        } catch {
            return "Common.Error";
        }
    }

    getFalseValidationRules = () => {
        return {
            minimal: false,
            uppercase: false,
            lowercase: false,
            digits: false,
            special_character: false,
            max_three_same_characters: false,
            no_6_repeatings: false,
            no_pointer_to_user: false,
        };
    }

    isMobile = () => window.innerWidth <= 992;
    pswdMatch = (values) => values.newPwd === values.confirmPwd;
    isFormValid = (values) => this.fieldsFilled(values) && this.pswdMatch(values);
    fieldsFilled = (values) => values.newPwd !== '' && values.confirmPwd !== '';
    isAppMember = (appName, apps = this.state.apps) => Array.isArray(apps) ? apps.some(x => x === appName) : false;
    processAppIds = (appIds) => !isNullOrUndefined(appIds) ? Object.keys(appIds).map(k => appIds[k]) : null;
    getAppLink = (appName, appLinks = this.state.appLinks) => !isNullOrUndefined(appLinks) ? appLinks[appName] : "";
}

const LostPwdBackground = ({ children }) => (
    <>
        {localStorage.locales_login === 'blue' && (
            <div className='app-screen app-loading-screen blue-background'>
                {isRepiWeb()
                    ? <img className='cribis-logo' alt="" src={getLanguage() === 'sk-SK' ? RepiSkWhite : RepiCzWhite}></img>
                    : <img className='cribis-logo' alt="" src={getLanguage() === 'sk-SK' ? cribislogowhiteSk : cribislogowhiteCz}></img>}
                {children}
            </div>
        )}
        {localStorage.locales_login === 'tree' && (
            <>
                <div className="app-screen app-loading-screen">
                    {isRepiWeb()
                        ? <img className='cribis-logo' alt="" src={getLanguage() === 'sk-SK' ? RepiSkGrey : RepiCzGrey}></img>
                        : <img className='cribis-logo' alt="" src={getLanguage() === 'sk-SK' ? cribislogograySk : cribislogograyCz}></img>}
                    {children}
                </div>
                <div className="cribis-tree">
                    <img alt="" src={criftimelinetrees} style={{ position: "absolute", bottom: "12vh", width: "100vw", opacity: "0.15" }}></img>
                </div>
            </>)}
    </>
);

const LostPwdAsForm = ({ children, ...rest }) => (
    <div className={classnames("justify-content-center", { 'vertical-center': localStorage.locales_login === 'tree' })}>
        <div className="columns is-centered" {...rest}>
            {children}
        </div>
    </div>
);

export default withLocalize(LostPwdComponent);
